// extracted by mini-css-extract-plugin
export default {"r_l":"cf08b14b1f c73a8a19d3","t":"_7f000a8a88"};